import React, { useEffect } from 'react';
import './Skills.css';

const Skills = () => {
  useEffect(() => {
    // Check if there's a hash in the URL
    const hash = window.location.hash;
    if (hash === '#top') {
      // Scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, []);
  const scrollToSection = (categoryName) => {
    const categoryElement = document.querySelector(`[data-category="${categoryName}"]`);
    if (categoryElement) {
      // Get navbar height to offset scroll
      const navbar = document.querySelector('.navbar');
      const navbarHeight = navbar ? navbar.offsetHeight : 80;
      
      // Calculate scroll position with offset
      const elementTop = categoryElement.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
      });
      
      // Add highlight effect
      categoryElement.classList.add('highlight-category');
      setTimeout(() => {
        categoryElement.classList.remove('highlight-category');
      }, 3000);
    }
  };

  const skillCategories = [
    {
      category: "Programming Languages & Frameworks",
      skills: [
        { name: "C#", level: 90, icon: "🔷" },
        { name: "JavaScript", level: 90, icon: (
          <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" style={{width: '32px', height: '32px'}}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M14.478,14.8829a4.06111,4.06111,0,0,1-2.18725-.39825,1.4389,1.4389,0,0,1-.53547-1.01019.22184.22184,0,0,0-.22662-.21942c-.31659-.00385-.63312-.003-.94965-.00043a.2113.2113,0,0,0-.23138.18628,2.33854,2.33854,0,0,0,.75305,1.84454,3.99135,3.99135,0,0,0,2.22827.8382,8.06151,8.06151,0,0,0,2.53308-.10755,3.12591,3.12591,0,0,0,1.67823-.90442,2.33824,2.33824,0,0,0,.396-2.23077,1.869,1.869,0,0,0-1.2304-1.09454c-1.28077-.4494-2.66431-.41541-3.97-.7569-.22668-.07135-.50366-.1488-.60467-.38879a.85461.85461,0,0,1,.28418-.95478,2.5576,2.5576,0,0,1,1.34875-.33581,4.07051,4.07051,0,0,1,1.88416.26959,1.43564,1.43564,0,0,1,.68677.99219.243.243,0,0,0,.2276.23565c.31433.00641.62878.00171.94311.00214a.22791.22791,0,0,0,.24732-.16772,2.43369,2.43369,0,0,0-1.18665-2.106,5.8791,5.8791,0,0,0-3.2182-.49243V8.08341a3.50546,3.50546,0,0,0-2.17615.87438,2.1746,2.1746,0,0,0-.43438,2.26264,1.92964,1.92964,0,0,0,1.21838,1.06177c1.27649.46106,2.67554.31311,3.96442.72082.25116.08521.54364.21552.6206.49506a.9907.9907,0,0,1-.26965.94616A2.97065,2.97065,0,0,1,14.478,14.8829Zm5.81891-8.44537q-3.73837-2.114-7.47845-4.22418a1.67742,1.67742,0,0,0-1.63733,0Q7.4556,4.31715,3.72968,6.42075a1.54242,1.54242,0,0,0-.8042,1.34271V16.2377a1.55266,1.55266,0,0,0,.8352,1.355c.71351.38837,1.40674.81629,2.13318,1.17884a3.06373,3.06373,0,0,0,2.73822.07525,2.1275,2.1275,0,0,0,.99482-1.92114c.00555-2.79669.00085-5.59351.00213-8.39026a.21981.21981,0,0,0-.20727-.25415c-.31739-.00513-.63526-.003-.95264-.00085a.20935.20935,0,0,0-.228.21368c-.00427,2.77875.00086,5.55829-.00256,8.33746a.94053.94053,0,0,1-.609.88373,1.53242,1.53242,0,0,1-1.23993-.16595q-.99152-.56-1.983-1.11988a.23714.23714,0,0,1-.13464-.23529q0-4.19383,0-8.38726a.2589.2589,0,0,1,.157-.2602Q8.1423,5.4553,11.85419,3.35953a.258.258,0,0,1,.29163.00043Q15.859,5.452,19.57184,7.5455a.262.262,0,0,1,.15613.26142Q19.72733,12,19.72712,16.19376a.242.242,0,0,1-.13294.23828q-3.65643,2.06753-7.31677,4.12909c-.11658.06494-.25458.16943-.39093.09076-.6391-.36176-1.27039-.73755-1.90735-1.10273a.20589.20589,0,0,0-.22968-.01379,5.21834,5.21834,0,0,1-.88208.41162c-.13806.05591-.30792.07184-.40295.19989a1.31566,1.31566,0,0,0,.43127.31061q1.11741.647,2.236,1.29285a1.62967,1.62967,0,0,0,1.65539.046q3.7261-2.101,7.45185-4.20392a1.55627,1.55627,0,0,0,.83563-1.35474V7.76346A1.53956,1.53956,0,0,0,20.29694,6.43753Z"></path>
            </g>
          </svg>
        ) },
        { name: "Java", level: 70, icon: "☕" },
        { name: "HTML/CSS", level: 90, icon: "🌐" },
        { name: "MERN Stack", level: 85, icon: "⚛️" },
        { name: "ASP.NET Core MVC", level: 90, icon: "🔷" },
        { name: ".NET MAUI", level: 80, icon: "📱" },
        { name: "Visual Studio", level: 90, icon: "💻" },
        { name: "VS Code", level: 85, icon: "📝" },
        { name: "GitHub", level: 85, icon: (
          <svg viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="currentColor" style={{width: '32px', height: '32px'}}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <title>github [#142]</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-140.000000, -7559.000000)" fill="currentColor">
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    <path d="M94,7399 C99.523,7399 104,7403.59 104,7409.253 C104,7413.782 101.138,7417.624 97.167,7418.981 C96.66,7419.082 96.48,7418.762 96.48,7418.489 C96.48,7418.151 96.492,7417.047 96.492,7415.675 C96.492,7414.719 96.172,7414.095 95.813,7413.777 C98.04,7413.523 100.38,7412.656 100.38,7408.718 C100.38,7407.598 99.992,7406.684 99.35,7405.966 C99.454,7405.707 99.797,7404.664 99.252,7403.252 C99.252,7403.252 98.414,7402.977 96.505,7404.303 C95.706,7404.076 94.85,7403.962 94,7403.958 C93.15,7403.962 92.295,7404.076 91.497,7404.303 C89.586,7402.977 88.746,7403.252 88.746,7403.252 C88.203,7404.664 88.546,7405.707 88.649,7405.966 C88.01,7406.684 87.619,7407.598 87.619,7408.718 C87.619,7412.646 89.954,7413.526 92.175,7413.785 C91.889,7414.041 91.63,7414.493 91.54,7415.156 C90.97,7415.418 89.522,7415.871 88.63,7414.304 C88.63,7414.304 88.101,7413.319 87.097,7413.247 C87.097,7413.247 86.122,7413.234 87.029,7413.87 C87.029,7413.87 87.684,7414.185 88.139,7415.37 C88.139,7415.37 88.726,7417.2 91.508,7416.58 C91.513,7417.437 91.522,7418.245 91.522,7418.489 C91.522,7418.76 91.338,7419.077 90.839,7418.982 C86.865,7417.627 84,7413.783 84,7409.253 C84,7403.59 88.478,7399 94,7399" id="github-[#142]"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        ) },
        { name: "Postman", level: 90, icon: "📮" },
        { name: "MongoDB Compass", level: 85, icon: "🍃" },
        { name: "Azure DevOps", level: 85, icon: "☁️" }
      ]
    },
    {
      category: "Databases & SQL",
      skills: [
        { name: "SQL Server", level: 85, icon: "🗄️" },
        { name: "SQL", level: 90, icon: "💾" },
        { name: "MongoDB", level: 80, icon: "🍃" },
        { name: "SSMS", level: 85, icon: "🔧" },
        { name: "Redgate Tools", level: 80, icon: "🛠️" }
      ]
    },
    {
      category: "Project & Code Management",
      skills: [
        { name: "Azure DevOps", level: 80, icon: "⚙️" },
        { name: "Kanban Boards", level: 85, icon: "📊" },
        { name: "Pull Requests", level: 85, icon: "🔀" },
        { name: "Code Reviews", level: 85, icon: "👁️" },
        { name: "Time Management", level: 80, icon: "⏰" }
      ]
    },
    {
      category: "Design & Office Tools",
      skills: [
        { name: "Adobe Photoshop", level: 75, icon: "🎨" },
        { name: "Microsoft Office", level: 90, icon: "📄" },
        { name: "Word", level: 90, icon: "📝" },
        { name: "Excel", level: 85, icon: "📊" },
        { name: "PowerPoint", level: 85, icon: "📽️" },
        { name: "Publisher", level: 75, icon: "📰" },
        { name: "Outlook", level: 80, icon: "📧" }
      ]
    },
    {
      category: "User Experience & Customer Service",
      skills: [
        { name: "User-Centric Design", level: 90, icon: "👥" },
        { name: "Accessibility Focus", level: 85, icon: "♿" },
        { name: "Technical Support", level: 85, icon: "🛠️" },
        { name: "Customer Communication", level: 90, icon: "💬" },
        { name: "Problem-Solving", level: 90, icon: "🔍" },
        { name: "Hardware Troubleshooting", level: 80, icon: "🔧" }
      ],
      learnMore: {
        text: "Learn More About My Background",
        link: "/about",
        section: "unique-background"
      }
    },
    {
      category: "Modern Development Tools",
      skills: [
        { name: "AI-Assisted Debugging", level: 75, icon: "🤖" },
        { name: "Responsible AI Usage", level: 85, icon: "🛡️" },
        { name: "Data Security", level: 90, icon: "🔒" },
        { name: "Independent Problem-Solving", level: 95, icon: "🧠" },
        { name: "Tool Integration", level: 80, icon: "🔗" }
      ],
      learnMore: {
        text: "Learn More About My AI Approach",
        link: "/about",
        section: "ai-integration"
      }
    }
  ];

  const getLevelColor = (level) => {
    if (level >= 90) return '#28a745';
    if (level >= 80) return '#17a2b8';
    if (level >= 70) return '#ffc107';
    return '#dc3545';
  };

  const getLevelText = (level) => {
    if (level >= 90) return 'Expert';
    if (level >= 80) return 'Advanced';
    if (level >= 70) return 'Intermediate';
    return 'Beginner';
  };

  return (
    <div className="skills">
      <div className="container">
        <section className="skills-hero">
          <h1 className="section-title">Skills & Technologies</h1>
          <p className="skills-intro">
            Here's an overview of my technical skills and proficiency levels. 
            I'm constantly learning and expanding my knowledge in new technologies.
          </p>
        </section>

        <section className="skills-overview">
          <div className="overview-grid">
            <div className="overview-card" onClick={() => scrollToSection('Programming Languages & Frameworks')}>
              <h3>Programming & Frameworks</h3>
              <p>Strong foundation in C#, JavaScript, and modern frameworks for building scalable applications</p>
            </div>
            <div className="overview-card" onClick={() => scrollToSection('Databases & SQL')}>
              <h3>Databases & APIs</h3>
              <p>Proficient in database design, SQL, and API development with tools like Postman</p>
            </div>
            <div className="overview-card" onClick={() => scrollToSection('Project & Code Management')}>
              <h3>DevOps & Management</h3>
              <p>Experience with project management, code reviews, and DevOps practices</p>
            </div>
            <div className="overview-card" onClick={() => scrollToSection('Design & Office Tools')}>
              <h3>Design & Office Tools</h3>
              <p>Proficient in Adobe Photoshop, Microsoft Office suite, and design tools for professional work</p>
            </div>
            <div className="overview-card" onClick={() => scrollToSection('User Experience & Customer Service')}>
              <h3>User Experience</h3>
              <p>Unique background in customer service drives user-centric design and accessibility focus</p>
            </div>
            <div className="overview-card" onClick={() => scrollToSection('Modern Development Tools')}>
              <h3>Modern Tools</h3>
              <p>Responsible integration of AI tools with emphasis on data security and independent problem-solving</p>
            </div>
          </div>
        </section>

        <section className="skills-detail">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category" data-category={category.category}>
              <h2 className="category-title">{category.category}</h2>
              <div className="skills-grid">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-icon">{skill.icon}</span>
                      <div className="skill-info">
                        <h3 className="skill-name">{skill.name}</h3>
                        <span className="skill-level">{getLevelText(skill.level)}</span>
                      </div>
                    </div>
                    <div className="skill-progress">
                      <div className="progress-bar">
                        <div 
                          className="progress-fill"
                          style={{ 
                            width: `${skill.level}%`,
                            backgroundColor: getLevelColor(skill.level)
                          }}
                        ></div>
                      </div>
                      <span className="progress-text">{skill.level}%</span>
                    </div>
                  </div>
                ))}
              </div>
              {category.learnMore && (
                <div className="learn-more-section">
                  <button 
                    onClick={() => {
                      // Navigate to About page with section parameter
                      window.location.href = `${category.learnMore.link}#${category.learnMore.section}`;
                    }}
                    className="btn btn-secondary learn-more-btn"
                  >
                    {category.learnMore.text}
                  </button>
                </div>
              )}
            </div>
          ))}
        </section>

        <section className="skills-cta">
          <div className="cta-content">
            <h2>Want to discuss what I could bring to your team?</h2>
            <p>Let's Talk!</p>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Email:</strong>
                <a href="mailto:JacobW@segotw.com">JacobW@segotw.com</a>
              </div>
              <div className="contact-item">
                <strong>Phone:</strong>
                <a href="tel:+13149399335">+1 (314) 939-9335</a>
              </div>
            </div>
            <div className="cta-buttons">
              <a href="/projects" className="btn btn-primary">
                View My Projects
              </a>
              <a href="/experience" className="btn btn-secondary">
                See My Experience
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Skills; 